module.exports = __webpack_public_path__ + "i18n/es_ebb22002244fbd7b9276b54087aef47c.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/es.json
// module id = +lAx
// module chunks = 154